import { render, staticRenderFns } from "./SocialAccountChoice.vue?vue&type=template&id=53ab62cb&"
import script from "./SocialAccountChoice.vue?vue&type=script&lang=js&"
export * from "./SocialAccountChoice.vue?vue&type=script&lang=js&"
import style0 from "./SocialAccountChoice.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports